import React, { useEffect, useState } from 'react';
import styles from './PhoneTab.module.css';
import { Box, CircularProgress, Paper, Typography, IconButton, Tooltip, Link } from '@mui/material';
import CallIcon from '@mui/icons-material/Call';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useNotificationProvider } from 'hooks';
import { getDispatchPhoneNumber } from 'api/canguard/getDispatchPhoneNumber';

interface PhoneBoxProps {
	text: string;
	phoneNumber: string;
}
const PhoneBox = ({ text, phoneNumber }: PhoneBoxProps) => {
	const { notifySuccess } = useNotificationProvider();

	return (
		<Box className={styles.phoneBox}>
			<Typography>{text}</Typography>
			<Box gap={2} className={styles.buttonWrapper}>
				<Tooltip title="Call">
					<Link href={`tel:${phoneNumber}>`}>
						<IconButton size="large">
							<CallIcon />
						</IconButton>
					</Link>
				</Tooltip>

				<Tooltip title="Copy">
					<IconButton
						size="large"
						onClick={() => {
							navigator.clipboard.writeText(phoneNumber);
							notifySuccess('Copied to clipboard');
						}}
					>
						<ContentCopyIcon />
					</IconButton>
				</Tooltip>
			</Box>
		</Box>
	);
};

function PhoneTab() {
	const [dispatchPhoneNumber, setDispatchPhoneNumber] = useState<string>('');
	const [loading, setLoading] = useState<boolean>(false);
	const { notifyError } = useNotificationProvider();

	const fetchPhoneNumbers = async () => {
		try {
			setLoading(true);
			const _dispatchPhoneNumber = await getDispatchPhoneNumber();
			setDispatchPhoneNumber(_dispatchPhoneNumber);
		} catch (error) {
			console.error('[PhoneTab/fetchPhoneNumbers] Error fetching phone numbers:', error);
			notifyError('Error fetching phone numbers');
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchPhoneNumbers();
	}, []);

	return (
		<div className={styles.wrapper}>
			<Paper elevation={1} sx={{ p: 2, width: 'fit-content' }}>
				<div className={styles.content}>
					{loading ? (
						<Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
							<CircularProgress size={40} />
						</Box>
					) : (
						<>
							<Typography
								variant="h5"
								sx={{ fontWeight: '300' }}
								color={'primary'}
							>
								Contacts
							</Typography>

							<PhoneBox
								text={`Call Dispatch at ${dispatchPhoneNumber}`}
								phoneNumber={dispatchPhoneNumber}
							/>
							<PhoneBox text="Call 911" phoneNumber="911" />
						</>
					)}
				</div>
			</Paper>
		</div>
	);
}

export default PhoneTab;
